<template>
    <header class="header">
        <h1 class="logo">
            <span class="logo-svg" @click="$router.push('/')">


                <!-- <svg viewBox="0 0 181.3 258.83" ref="logo"> -->
                <svg viewBox="0 0 190 260" ref="logo">
                <path d="M12.82,98.67c0,2.6,0.26,9.36,0.26,17.16v33.8H3.46v-68.9h9.1l29.12,43.16c6.24,9.36,6.5,9.62,6.5,7.8
                    c0-2.6-0.26-9.36-0.26-17.16v-33.8h9.36v68.9h-9.1l-28.86-43.16C13.08,97.11,12.82,96.85,12.82,98.67z M138.66,199.29h32.76v21.32
                    h-27.04v9.36h27.04v19.5h-30.94v9.36h40.82v-68.9h-42.64V199.29z M112.4,180.83h9.36v-27.04h59.54v-10.14h-68.9V180.83z
                    M112.4,80.73h68.9v26c0,10.66-5.98,21.58-17.94,21.58c-7.54,0-13-3.64-15.34-10.4c-2.6,6.76-8.58,10.4-17.68,10.4
                    c-7.8,0-13.26,1.04-17.94,2.86v-10.4c2.6-1.3,7.54-2.6,14.82-2.6c10.14,0,15.6-3.38,15.6-13.26V90.87H112.4V80.73z M152.18,107.77
                    c0,7.02,3.9,10.4,10.14,10.4c6.24,0,9.36-4.68,9.36-11.44V90.87h-19.5V107.77z M104.86,70.07h9.88V1.17h-9.88v28.34H71.84V1.17H61.7
                    v68.9h10.14v-31.2h33.02V70.07z M37,226.52v22.95h20.02v9.36H7.36v-9.36h20.02v-22.95c-15.35-2.02-27.3-13.69-27.3-35.03
                    c0-21.32,13-35.88,32.24-35.88s31.98,14.56,31.98,35.88C64.3,212.83,52.35,224.5,37,226.52z M27.38,217.23v-27.3H37v27.3
                    c10.66-1.82,18.2-10.66,18.2-25.22c0-16.64-8.06-27.3-22.88-27.3c-14.82,0-23.14,10.66-23.14,27.3
                    C9.18,206.57,16.72,215.41,27.38,217.23z M101.22,198.51c10.4,0,15.08,5.2,15.34,12.48h9.88c-0.26-13-9.1-21.84-25.22-21.84
                    c-14.3,0-25.48,8.06-25.48,20.54c0,10.92,7.02,17.42,19.76,20.28c1.82,0.52,7.02,1.56,8.58,1.82c5.98,1.3,10.66,3.38,10.66,9.88
                    c0,6.76-6.24,9.62-14.04,9.36c-7.54-0.26-13.26-3.12-14.3-10.92h-9.62c1.04,12.48,9.36,20.02,24.44,20.02
                    c13,0,23.66-6.5,23.66-19.24c0-5.72-2.08-10.66-5.98-13.52c-5.72-4.42-12.74-5.46-20.54-7.02c-7.28-1.56-12.74-4.42-12.74-10.92
                    C85.62,202.67,92.12,198.51,101.22,198.51z M30.79,61.87c-11.16,0-21.1-7.28-21.1-25.17c0-16.65,9.37-27.19,22.24-27.19
                    c5.3,0,10.6,1.61,16.27,5.2V4.54C42.9,1.42,37.13,0,31.93,0C14.43,0,0.04,15.33,0.04,37.75c0,21,14.29,33.49,30.27,33.49
                    c8.04,0,14.85-2.37,20.25-6.72V53.55C43.84,59.32,38.83,61.87,30.79,61.87z M143.39,42.82h19.15l-9.52-28.78L143.39,42.82z
                    M140.45,52.44l-6.18,17.63h-10.13l23.61-68.9h10.44l23.61,68.9h-10.13l-6.18-17.63H140.45z"/>
                </svg>
            </span>
        </h1>
    </header>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';
let logo_animation = null;

export default {
    name: 'site-header',

    data () {
        return {
            // width: 15,
            is_mobile: false,
            opacity: 1,
            last_scroll_position: 0,
            navi: [],
        }
    },

    watch: {
        '$route.params': {
            handler(params) {
                // if (this.is_mobile) {
                //     this.width = 15;
                // } else {
                //     this.width = 15;
                // }


                if (this.$route.name === 'home') {
                    let offset = .97;
                    let color = '#e1f500';

                    if (this.is_mobile) {
                        offset = .95;
                    }

                    if (document.documentElement.classList.contains('theme-color-2')) {
                        color = '#ffaf00';
                    }

                    this.$refs.logo.setAttribute('width', window.innerWidth * .2 + 'px');
                    this.$refs.logo.setAttribute('height', window.innerWidth * (.2 * 1.3333)  + 'px');

                    logo_animation = anime({
                        targets: this.$refs.logo,
                        fill: color,
                        width: window.innerWidth * (1 * offset),
                        height: window.innerWidth * (1.3333 * offset),
                        delay: function(el, i) { 
                            return i * 100; 
                        },
                        elasticity: 200,
                        easing: 'easeInOutSine',
                        autoplay: false
                    });
                } else {
                    logo_animation = null;
                    if (this.$refs.logo) this.$refs.logo.removeAttribute('style');
                }
                
                this.opacity = 0;
            },

            immediate: true,
        }
    },

    methods: {
        onScroll () {
            if (this.$route.name === 'home') {
                if (this.is_mobile) {
                    this.opacity = (window.pageYOffset/(window.innerHeight*1.03));
                    // this.width = 15 + (87 * this.opacity);
                    // if (this.width > 97) this.width = 97;
                } else {
                    this.opacity = (window.pageYOffset/(window.innerHeight*1.05));
                    // this.width = 15 + (82 * this.opacity);
                    // if (this.width > 95) this.width = 95;
                }

            } else {
                this.opacity = 0;
            }


            if (logo_animation !== null) logo_animation.seek(logo_animation.duration * this.opacity);

            
            // if (window.pageYOffset < 0) {
            //     return;
            // }

            // if (Math.abs(window.pageYOffset - this.last_scroll_position) < 100) {
            //     return;
            // }

            // this.show_header = window.pageYOffset < this.last_scroll_position;
            // this.last_scroll_position = window.pageYOffset;
        }
    },


    mounted () {
        this.is_mobile = (window.innerWidth > 800);
        if (this.is_mobile) {
            this.width = 15;
        }
        
        this.last_scroll_position = window.pageYOffset;
        this.onScroll();
        window.addEventListener('scroll', this.onScroll);



    },

}
</script>

<style lang="scss">
    // @import '@../../../../public/webui/sass/partials/variable';

    .logo {

        * {
            transform: translate3d(0,0,0);
            perspective: 1000;
        }


        
        // .bottom {
        //     z-index: 1;
        //     display: none;
        // }
    }
    
    body.not-home {
        .logo-svg {
            max-width: 15rem;
        }

        .logo {
            span,
            a {
                display: block;
                width: 15rem;

                &::before {
                    display: block;
                    width: 100%;
                    padding-bottom: 145%;
                    content: '';
                }
            }

            a {
                position: absolute;
                right:  var(--padding);
                top: calc(var(--padding) + .5rem);
                z-index: 99999;
            }


            span {
                position: absolute;
                right:  var(--padding);
                top: calc(var(--padding) + .5rem);
                z-index: 9999;
            }

            svg {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 3;
                fill: black;
                height: 100%;
                width: 100%;
            }
        }

    
    }

    body.page-home {
        .logo {


            svg {
                fill: white;
                position: fixed;
                right:  var(--padding);
                top: var(--padding);
                z-index: 9;
                min-width: 20vw;
                min-height: 29vw;
            }

            .logo-svg {
                max-width: unset;
            }



            // svg {
            //     fill: white;
            // }
            
            // .bottom {
            //     display: block;
            //     fill: var(--yellow);

            // }
        }
    }

    @media only screen and (max-width: 767px) {
        .woocommerce-page {
            .logo svg {
                width: 100% !important;
            }
        }

        body.not-home {
            .logo-svg {
                max-width: 30rem;
            }

            .logo {
                span,
                a {
                    display: block;
                    width: 100%;
                }

                a {
                    position: absolute;
                    top: 0;
                    right: calc(50% - 15rem);
                    top: 0;
                    width: 30rem;
                }


                span {
                    right:  0;
                    top: 0;
                    position: relative;
                    display: block;
                    margin: 0 auto;
                }

                svg {
                    left: 50%;
                    top: 50%;
                    right: auto;
                    height: 68%;
                    transform: translate(-50%, -50%);
                }
            }

        
        }

        body.not-home .logo span::before, body.not-home .logo a::before {
            padding-bottom: 150%;
        }
        
        body.page-home {
            .logo {


                svg {
                    right:  auto;
                    left: 50%;
                    transform: translate(-50%, 0);
                    min-width: 26vw;
                    min-height: 38vw;
                }

                .logo-svg {
                    max-width: unset;
                }




            }
        }
        // .logo {
        //     display: block;
        //     padding: var(--padding) 0 var(--padding-x2);

        //     a {
        //         display: none;

        //     }

        //     span {
        //         position: relative;
        //         display: block;
        //         top: 0;
        //         right: auto;
        //         left: 50%;
        //         transform: translate( -50%, 0);
        //     }

        //     .logo-svg {
        //         min-width: 25rem;
        //     }
        // }
        

    }

</style>
